import React from 'react';

import PageContent from 'components/PageContent';
import CurrencyMbTable from 'components/CurrencyMbTable';
import CurrencyNews from 'components/CurrencyNews';
import CurrencyConverter from 'components/CurrencyConverter';
import CurrencyMbTimeLine from 'components/CurrencyMbTimeLine';
import Banner from 'components/Banner';
import ExchangeDiscussion from 'components/ExchangeDiscussion';
import NewsSlider from 'components/NewsSlider';
import CurrencyArticles from 'components/CurrencyArticles';

const MbPageContent = () => (
  <PageContent>
    <CurrencyMbTable />
    <Banner id="hp-react-banner-content-1" slot="bn-slot-content-1" />
    <CurrencyMbTimeLine />
    <Banner id="hp-react-banner-content-2" slot="bn-slot-content-2" />
    <CurrencyConverter optionType="interbank" />
    <ExchangeDiscussion />
    <NewsSlider />
    <CurrencyNews />
    <CurrencyArticles />
  </PageContent>
);

export default MbPageContent;
